import React from 'react'
import { Outlet } from 'react-router-dom';

function ErrorsLayout() {
  return (
    <div className="w-screen h-screen bg-white dark:bg-gray-900">
        <Outlet />
    </div>
  )
}

export default ErrorsLayout;
